module.exports = __webpack_public_path__ + "static/media/class_small_shaman.6ebd9c99.png";